import * as types from './actionTypes';  
import offeringStatsApi from '../api/offeringStatsApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchOfferingStats() {

  return {
    type: types.DO_FETCH_OFFERING_STATS
    
  };
}

export function doFetchOfferingStatsRes(data) {  
  return {
    type: types.DO_FETCH_OFFERING_STATS_RES, 
    data
  };
}

export function fetchOfferingStats() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      offeringStatsApi.doFetchOfferingStats().then(data => {
        dispatch(doFetchOfferingStatsRes(data));
        dispatch(doFetchOfferingStatsRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}